<template>
  <section :class="classes">
    <div class="container">
      <nav class="level">
        <!-- Left side -->
        <div class="level-left">
          <div class="level-item">
            <span class="brand">
              ZUL
              <span class="brand-city">{{ $root.app.cityName }}</span>
            </span>
          </div>
        </div>

        <!-- Right side -->
        <div class="level-right">
          <Language />
          <p v-if="pendingOrder" class="level-item">
            <a @click="viewPendingOrder()">{{$t('global.orderPending')}}</a>
          </p>
          <p class="level-item"><a @click="logout()">{{$t('global.logout')}}</a></p>
        </div>
      </nav>

      <div class="wrap columns is-multiline">
        <div class="side column is-4">
          <Profile></Profile>
          <Activation v-if="activation"></Activation>
          <Regularize v-if="supportsRegularization" :supportsActCode="supportsActCode"></Regularize>
          <Vehicles></Vehicles>
        </div>

        <div class="column is-8">
          <div class="main columns is-gapless is-multiline">
            <div class="column is-5">
              <user-cards></user-cards>
            </div>

            <div class="column is-7">
              <balance></balance>
            </div>

            <div class="column is-12">
              <historic></historic>
            </div>
          </div>
        </div>
      </div>
    </div>

    <zul-modal
      class="is-medium"
      v-if="pendingOrder"
      ref="pendingModal"
      title="Boleto pendente"
    >
      <div v-if="isCancelingOrder">
        <p class="loading">{{$t('global.canceling')}}</p>
      </div>
      <div v-else>
        <p class="pending-title">
          <strong>{{ $t('global.paymentPending') }}</strong> {{ $t('global.dueDate') }}:
          {{ pendingOrder.dueDate }}
        </p>
        <bankslip :data="pendingOrder"></bankslip>
      </div>
    </zul-modal>
    <PixModal :order="pendingOrder" ref="pixModal"></PixModal>
    <support-modal></support-modal>
    <masterpass-modal></masterpass-modal>
    <subscription-modal></subscription-modal>
    <terms-modal></terms-modal>

    <a class="support-button" @click="$root.$emit('open-support-modal')">?</a>
  </section>
</template>

<script>
import Profile from "./Dashboard/Profile.vue";
import Regularize from "./Dashboard/Regularize.vue";
import Activation from "./Dashboard/Activation.vue";
import Vehicles from "./Dashboard/Vehicles.vue";
import UserCards from "./Dashboard/UserCards.vue";
import Balance from "./Dashboard/Balance.vue";
import Historic from "./Dashboard/Historic.vue";

import Bankslip from "../components/Bankslip.vue";
import PixModal from "../components/Pix.vue";

import SupportModal from "../modals/Support.vue";
import MasterpassModal from "../modals/Masterpass.vue";
import SubscriptionModal from "../modals/Subscription.vue";

import TermsModal from "../modals/Terms.vue";
import Button from '../components/Button.vue';

import Language from '../components/Language.vue';


export default {
  name: "Dashboard",
  props: {},
  data() {
    const user = this.$auth.user();

    return {
      ticket: {
        name: user.name,
        email: user.email,
      },
      pendingOrder: null,
      isCancelingOrder: false,
      supportsRegularization: false,
      supportsActCode: false
    };
  },

  computed: {
    classes() {
      return {
        dashboard: true,
        section: true,
        "is-bhz": this.$root.app.city === "BHZ",
        "is-cwb": this.$root.app.city === "CWB",
        "is-ftz": this.$root.app.city === "FTZ",
        "is-ssa": this.$root.app.city === "SSA",
        "is-jdn": this.$root.app.city === "JDN",
        "is-cjz": this.$root.app.city === "CJZ",
        "is-mon": this.$root.app.city === "MON",
        "is-sgr": this.$root.app.city === "SGR",
        // estapar
        "is-ame": this.$root.app.city === "AME",
        "is-ara": this.$root.app.city === "ARA",
        "is-ita": this.$root.app.city === "ITA",
        "is-jac": this.$root.app.city === "JAC",
        "is-jzf": this.$root.app.city === "JZF",
        "is-lim": this.$root.app.city === "LIM",
        "is-mog": this.$root.app.city === "MOG",
        "is-mau": this.$root.app.city === "MAU",
        'is-mcl': this.$root.app.city === 'MCL',
        "is-ric": this.$root.app.city === "RIC",
        "is-sbo": this.$root.app.city === "SBO",
        "is-sta": this.$root.app.city === "STA",
        "is-sbc": this.$root.app.city === "SBC",
        "is-sca": this.$root.app.city === "SCA",
        "is-sbv": this.$root.app.city === "SBV",
        "is-ssg": this.$root.app.city === "SSG",
        "is-sao": this.$root.app.city === "SAO",
        "is-tau": this.$root.app.city === "TAU",
      };
    },
    activation() {
      return ["CJZ", "JDN", "MON", "SGR",
        "AME", "ARA", "ITA", "JAC", "JZF", "LIM", "MOG", "RIC", "SAO", "SBC", "SBO", "SCA", "SBV", "SSG", "STA", "TAU", "MAU", "MCL"]
        .indexOf(this.$root.app.city) >= 0;
    }
  },

  created() {
    // Pending order
    if (this.$auth.user().pendingOrder) {
      this.pendingOrder = this.$auth.user().pendingOrder;

      this.pendingOrder.product = {
        cads: this.pendingOrder.cads,
        total: this.pendingOrder.total,
      };

      this.pendingOrder.title =
        "Compra de " + this.$root.app.service + " (pendente)";
      this.pendingOrder.summary = this.pendingOrder.cads + " Cartões";
    }

    this.$root.$on("cancel-bankslip-start", () => {
      this.isCancelingOrder = true;
    });

    this.$root.$on("cancel-bankslip-end", () => {
      if (this.$refs.pendingModal) {
        this.pendingOrder = null;
        this.isCancelingOrder = false;
        this.$refs.pendingModal.close();
      }
    });

    this.$root.$on("set-pending-order", (order) => {
      this.pendingOrder = order;
      this.$forceUpdate();
    });

    this.PARKING.get('/public-parking/login').then(res => {
      this.supportsRegularization = res.data.supportsRegularization
      this.supportsActCode = res.data.supportsActCode
    })
  },
  mounted() {
    if (this.$root.redirect) {
      if (this.$root.redirect.matched[0].path === "/insurance") {
        this.$root.$emit("open-insurance-modal", this.$root.redirect.params);
      } else if (this.$root.redirect.matched[0].path === "/subscription") {
        /*else if (this.$root.redirect.matched[0].path ===  '/quote') {
        this.$root.$emit('open-licensing-modal', this.$root.redirect.params)
      }*/
        this.$root.$emit("open-subscription-modal", this.$root.redirect.params);
      } else if (this.$root.redirect.matched[0].path === "/taxes") {
        this.$root.$emit("open-taxes-modal", this.$root.redirect.params);
      }
      /*else if (this.$root.redirect.matched[0].path ===  '/licensing') {
        this.$root.$emit('open-licensing-modal', this.$root.redirect.params)
      }*/

      delete this.$root.redirect;
    }
  },
  methods: {
    logout() {
      this.$auth.logout();
    },

    viewPendingOrder() {
      if (this.pendingOrder.paymentType === "PIX") {
        this.$refs.pixModal.open();
      } else {
        this.$refs.pendingModal.open();
      }
    },
  },
  components: {
    Profile,
    Regularize,
    Activation,
    Vehicles,
    UserCards,
    Balance,
    Historic,
    Bankslip,
    SupportModal,
    // InsuranceModal,
    MasterpassModal,
    // LicensingModal,
    SubscriptionModal,
    TermsModal,
    PixModal,
    Button,
    Language
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../assets/sass/variables";

html,
body,
.dashboard,
.container,
.wrap,
.main {
  height: 100%;
}

.main {
  .column {
    height: 140px;
  }
  .is-12 {
    height: calc(100% - 140px);

    > div,
    > div > .box {
      height: 100%;
    }
  }
}

.brand {
  color: $white;
  font-size: 26px;
  font-weight: bold;

  @each $city, $map in $cities {
    .is-#{$city} & {
      color: map-get($map, "primary");
    }
  }

  .brand-city {
    font-weight: normal;
    color: $white;
  }
}

.support-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  border: 3px white solid;
  font-weight: bold;
  font-size: $size-3;
  border-radius: 100px;
  width: 55px;
  height: 55px;
  text-align: center;
  color: $white;

  &:hover {
    color: $white;
  }

  // multicity colors
  @each $city, $map in $cities {
    .is-#{$city} & {
      background-color: map-get($map, "primary");
    }
  }
}

.dashboard {
  .level {
    a {
      color: $white;
    }
  }

  .box {
    position: relative;
    background: $grey-darker;
    color: $white;
    padding: 1.75rem;
    border-radius: 0;
    height: 100%;

    p {
      color: $white;
    }

    > .title {
      color: $white;
      font-size: $size-6;
      font-weight: normal;

      &::after {
        content: " ";
        display: block;
        //background-color: $primary;
        width: 13px;
        height: 2px;
        margin-top: 7px;

        @each $city, $map in $cities {
          .is-#{$city} & {
            background-color: map-get($map, "primary");
          }
        }
      }
    }
  }
}

.pending-title {
  text-align: center;
  margin: 1rem 0 1.5rem;
}

.loading {
  background: url("../assets/loading.svg") no-repeat center 35%;
  background-size: 100px;
  text-align: center;
  padding: 7rem 0 0;
  font-size: $size-7;
  opacity: 0.5;
  margin-right: 0;
}
</style>
